/* eslint-disable @typescript-eslint/no-explicit-any */

import { ProxyCache } from '@/library/proxy';
import { Location } from '@/services/locationService';

declare let google: any;
let geocoder: any;
const w = (window as any);

async function sleep(ms: number) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(), ms);
  });
}
// eslint-disable-next-line no-underscore-dangle
export async function _getLocationByZipcode(zipcode: string): Promise<Location> {
  while (!(w.AppSettings || !w.AppSettings.googleLoaded)) {
    // eslint-disable-next-line no-await-in-loop
    await sleep(1000);
  }

  geocoder = new google.maps.Geocoder();
  if (!geocoder) {
    return Promise.reject();
  }
  return new Promise((resolve, reject) => {
    geocoder.geocode({ address: `${zipcode} Nederland` }, (results: any[], status: any) => {
      if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
        return resolve({
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng(),
        });
      }
      return reject(status);
    });
  });
}

export const getLocationByZipcode = new (ProxyCache as any)(_getLocationByZipcode) as
  (zipcode: string) => Promise<Location>;
